define('AvoidCategories', [
    'Categories',
    'underscore',
    'SC.Configuration',
    'Categories.Utils'
], function AvoidCategories(
    Categories,
    _,
    Configuration,
    CategoriesUtils
) {
    'use strict';

    Categories.makeNavigationTab = function makeNavigationTab(categories) {
        var result = [];
        var self = this;

        _.each(categories, function iterator(category) {
            var href = category.fullurl;
            var tab = {
                href: href,
                text: category.name,
                data: {
                    hashtag: '#' + href,
                    touchpoint: 'home'
                },
                'class': 'header-menu-level' + category.level + '-anchor',
                'data-type': 'commercecategory'
            };

            tab.additionalFields = CategoriesUtils.getAdditionalFields(
                category,
                'categories.menu.fields'
            );

            if (category.categories) {
                tab.categories = self.makeNavigationTab(category.categories);
            }

            if (tab.categories && tab.text !== 'Sale') {
                result.push(tab);
            }
        });

        return result;
    };
});
